import React from "react";

const ButtonEditRadius = ({ pageDetails, updateBBR }) => {
  return (
    <div className="block-section button">
      <div
        className={
          pageDetails.HasCustomTheme
            ? "grid-buttons"
            : "grid-buttons disabled-section"
        }
      >
        <div className="button-styled">
          {" "}
          <div
            className={`${
              pageDetails.ButtonBorderRadius === "0px"
                ? "button-styled-template selected squared"
                : "button-styled-template squared"
            }`}
            onClick={() => {
              updateBBR("0px");
            }}
          >
            Carré
          </div>
        </div>
        <div className="button-styled">
          {" "}
          <div
            className={`${
              pageDetails.ButtonBorderRadius === "8px"
                ? "button-styled-template selected rounded"
                : "button-styled-template rounded"
            }`}
            onClick={() => {
              updateBBR("8px");
            }}
          >
            Arrondi
          </div>
        </div>
        <div className="button-styled">
          {" "}
          <div
            className={`${
              pageDetails.ButtonBorderRadius === "40px"
                ? "button-styled-template selected round"
                : "button-styled-template round"
            }`}
            onClick={() => {
              updateBBR("40px");
            }}
          >
            Rond
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonEditRadius;
